import {lazyComponent} from 'coreUtils/adapters/lazy';

const CountryRedirectPopup = lazyComponent(() => import('./CountryRedirectPopup'));

export {CountryRedirectPopup as default};
